/**
 * action types
 */
export const INSTITUTION_SET_WHITE_LABEL_LOGO_URL_START =
  'INSTITUTION_SET_WHITE_LABEL_LOGO_URL_START';
export const INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS =
  'INSTITUTION_SET_WHITE_LABEL_LOGO_URL_SUCCESS';
export const INSTITUTION_SET_WHITE_LABEL_LOGO_URL_FAILURE =
  'INSTITUTION_SET_WHITE_LABEL_LOGO_URL_FAILURE';
export const INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_START =
  'INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_START';
export const INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_SUCCESS =
  'INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_SUCCESS';
export const INSTITUTION_SET_WHITE_LABEL_LOGO_ENABLED_FAILURE =
  'INSTITUTION_SET_WHITE_LABEL_LOGO_URL_FAILURE';
export const INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_START =
  'INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_START';
export const INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_SUCCESS =
  'INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_SUCCESS';
export const INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_FAILURE =
  'INSTITUTION_SET_WHITE_LABEL_ITEM_VISIBILITY_FAILURE';
export const INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_START =
  'INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_START';
export const INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_SUCCESS =
  'INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_SUCCESS';
export const INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_FAILURE =
  'INSTITUTION_SET_WHITE_LABEL_VISIBILITY_ROLE_SETTING_FAILURE';
export const INSTITUTION_CREATE_PORTAL = 'INSTITUTION_CREATE_PORTAL';
export const INSTITUTION_CREATE_PORTAL_SUCCESS =
  'INSTITUTION_CREATE_PORTAL_SUCCESS';
export const INSTITUTION_CREATE_PORTAL_ERROR =
  'INSTITUTION_CREATE_PORTAL_ERROR';
